module.exports = __webpack_public_path__ + "img/yctiwy-11.0d60969e.jpg";